export const DEFAULT_PORTFOLIO_ID = '3993816a-674d-40b8-b4fd-08b905b17d3b';